module.exports = __webpack_public_path__ + "img/Beach.5ab53092.jpeg";